const HEX6 = /^#[0-9A-Fa-f]{6}$/;

/**
 * Stored banner/login surface color. Omitted when it matches primary (nav and login gradient follow primary).
 */
export function normalizeBannerColorForStorage(bannerHex: string, primaryHex: string): string | undefined {
  const b = bannerHex.trim();
  const p = primaryHex.trim();
  if (!HEX6.test(b)) return undefined;
  if (HEX6.test(p) && b.toLowerCase() === p.toLowerCase()) return undefined;
  return b;
}

/** Resolve hex banner for styling: explicit banner or null to use theme primary. */
export function resolvedBannerBackgroundHex(banner?: string | null): string | null {
  if (typeof banner !== 'string') return null;
  const t = banner.trim();
  return HEX6.test(t) ? t : null;
}

/**
 * Gradient end color for portal auth surfaces (e.g. subdomain login): explicit `banner_color`, else valid `primary_color`.
 */
export function resolvedBannerOrPrimaryBackgroundHex(branding: {
  banner_color?: string | null;
  primary_color?: string | null;
}): string | null {
  const fromBanner = resolvedBannerBackgroundHex(branding.banner_color ?? undefined);
  if (fromBanner) return fromBanner;
  return resolvedBannerBackgroundHex(
    typeof branding.primary_color === 'string' ? branding.primary_color : undefined,
  );
}
